/**
 * Inicialização do I18n
 *
 * Este arquivo garante que o I18n esteja disponível globalmente
 * antes de qualquer módulo ser carregado.
 *
 * As traduções são carregadas diretamente no HTML via tags <script>
 * antes do Vite ser carregado:
 * 1. /javascripts/i18n.js - Define window.I18n
 * 2. /javascripts/translations.js - Define window.I18n.translations
 *
 * Este arquivo apenas verifica se tudo está correto e preserva
 * as configurações de locale.
 */

import I18n from 'i18n-js';

// Disponibilizar I18n globalmente
// Se I18n já foi carregado via script tag (i18n.js), usar esse
// Caso contrário, usar o import do npm
if (typeof window !== 'undefined') {
  const existingI18n = window.I18n;

  // Se I18n já existe (carregado via script tag), mesclar funcionalidades
  // do npm package se necessário, mas preservar as traduções já carregadas
  if (existingI18n && existingI18n.translations && Object.keys(existingI18n.translations).length > 0) {
    // I18n já foi carregado via script tag com traduções
    // Apenas garantir que o objeto está completo
    window.I18n = existingI18n;
  } else {
    // I18n não foi carregado via script tag, usar o do npm
    window.I18n = I18n;

    // Inicializar traduções vazias se não existirem
    if (!window.I18n.translations) {
      window.I18n.translations = {};
    }

    // Se havia um stub, copiar suas propriedades
    if (existingI18n && existingI18n !== I18n) {
      if (existingI18n.locale) window.I18n.locale = existingI18n.locale;
      if (existingI18n.defaultLocale) window.I18n.defaultLocale = existingI18n.defaultLocale;
      if (existingI18n.translations) {
        window.I18n.translations = { ...existingI18n.translations, ...window.I18n.translations };
      }
    }
  }

  // Verificar se as traduções foram carregadas
  if (!window.I18n.translations || Object.keys(window.I18n.translations).length === 0) {
    console.warn('Traduções do i18n-js não foram carregadas. Verifique se os arquivos i18n.js e translations.js estão sendo carregados no HTML.');
  }
}

export default (typeof window !== 'undefined' && window.I18n) || I18n;
